import { inject, isDevMode } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { PortalTypes } from '@shared/enums';
import { Toast } from '@shared/components/toast';
import { ToastService } from '@shared/components/toast';
import { TenancyContext } from '@core/tenancy';

export const handleNavigationError = (error: NavigationError) => {
  const toastService = inject(ToastService);
  const router = inject(Router);
  const tenancy = inject(TenancyContext);
  const portalType = PortalTypes.PUBLIC;
  toastService.show(NAVIGATION_ERROR_TOAST);

  if (isDevMode()) console.error('Navigation Error:', error);

  router.navigate([tenancy.link(portalType, 'access', 'login')]);
};

const NAVIGATION_ERROR_TOAST: Toast = {
  type: 'error',

  message: 'Oops! We had a navigation error.',
} as const;
